import history from '../../util/history'

const toSegmentView = reservationId => {
  history.replace(`/reservation/${reservationId}/segment`)

  return true
}

export default toSegmentView
